<ng-container *ngrxLet="conversation$ as conversation">
  <div
    *ngIf="(minimized$ | async) === false"
    class="conv-dialog-wrapper"
    tabindex="0"
  >
    <div class="conv-dialog-container" data-omni-qa="conv-dialog">
      <cigna-omni-messaging-list
        id="printSection"
        (messageViewed)="setMessageViewed($event)"
        (sendCta)="postCta($event)"
        (navigateBack)="navigateBack()"
        [conversationType]="conversationType$ | async"
        [disclaimer]="disclaimer$ | async"
        [messages]="events$ | async"
        [outroObj]="outroObj$ | async"
        [conversation]="conversation"
        [isLiveChatAvailable]="liveChatAvailable$ | async"
        [isUnmuted]="isUnmuted$ | async"
        [chatTitle]="title$ | async"
        [isHistoryView]="isHistoryView$ | async"
        [shouldEnablePreChatWelcome]="shouldEnablePreChatWelcome$ | async"
        [isUseRightNowChat]="useRightNowChat$ | async"
        [shouldEnabledBackToPrevious]="shouldEnabledBackToPrevious$ | async"
      ></cigna-omni-messaging-list>

      <cigna-omni-messaging-input
        *ngIf="inputEnabled$ | async"
        (sendMessage)="postMessage($event, conversation)"
        (keyUp)="keyHandler()"
        [shouldEnablePreChatWelcome]="shouldEnablePreChatWelcome$ | async"
      ></cigna-omni-messaging-input>
    </div>
  </div>
  <cigna-omni-splash-close-screen
    [screenText]="screenText"
    [conversationId]="conversation?._id"
    *ngIf="closeSplashScreen$ | async"
  ></cigna-omni-splash-close-screen>
</ng-container>
